var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-home",
    clipPath: "url(#clip0_1082_9315)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5605 4.53456L7.76801 0.741555C7.29863 0.27355 6.66284 0.0107422 6.00001 0.0107422C5.33718 0.0107422 4.70139 0.27355 4.23201 0.741555L0.439506 4.53456C0.299719 4.67345 0.188891 4.83871 0.113447 5.02075C0.0380036 5.20279 -0.0005552 5.398 6.03974e-06 5.59506V10.5036C6.03974e-06 10.9014 0.158041 11.2829 0.439346 11.5642C0.72065 11.8455 1.10218 12.0036 1.50001 12.0036H10.5C10.8978 12.0036 11.2794 11.8455 11.5607 11.5642C11.842 11.2829 12 10.9014 12 10.5036V5.59506C12.0006 5.398 11.962 5.20279 11.8866 5.02075C11.8111 4.83871 11.7003 4.67345 11.5605 4.53456ZM7.50001 11.0036H4.50001V9.03656C4.50001 8.63873 4.65804 8.2572 4.93935 7.97589C5.22065 7.69459 5.60218 7.53656 6.00001 7.53656C6.39783 7.53656 6.77936 7.69459 7.06067 7.97589C7.34197 8.2572 7.50001 8.63873 7.50001 9.03656V11.0036ZM11 10.5036C11 10.6362 10.9473 10.7633 10.8536 10.8571C10.7598 10.9509 10.6326 11.0036 10.5 11.0036H8.50001V9.03656C8.50001 8.37351 8.23662 7.73763 7.76777 7.26879C7.29893 6.79995 6.66305 6.53656 6.00001 6.53656C5.33697 6.53656 4.70108 6.79995 4.23224 7.26879C3.7634 7.73763 3.50001 8.37351 3.50001 9.03656V11.0036H1.50001C1.3674 11.0036 1.24022 10.9509 1.14645 10.8571C1.05268 10.7633 1.00001 10.6362 1.00001 10.5036V5.59506C1.00047 5.46254 1.0531 5.33555 1.14651 5.24156L4.93901 1.45006C5.22086 1.16952 5.60234 1.01203 6.00001 1.01203C6.39767 1.01203 6.77916 1.16952 7.06101 1.45006L10.8535 5.24306C10.9465 5.33668 10.9992 5.46307 11 5.59506V10.5036Z",
    fill: "#787878"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1082_9315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.6042bb106f05f279b57c0394d941a09a.svg";
export { ForwardRef as ReactComponent };